import { render } from "./historySubjectList.vue?vue&type=template&id=3b4fe65a"
import script from "./historySubjectList.vue?vue&type=script&lang=js"
export * from "./historySubjectList.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__